export default __webpack_public_path__ + "media/images/images/portrait/small/avatar-s-1-9ebed20a3dd3ed4f8321fa0f43690e79.png";